import React from 'react';
import GNdaFilesTable from '../../tables/GNdaFilesTable';

export default function NdasTab() {
    return (
        <div className='standard-div'>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                <div className='standard-div-flex'>
                    <h1>NDA Files</h1>
                </div>
                <div style={{ width: '100%' }}>
                    <GNdaFilesTable />
                </div>
            </div>
        </div>
    );
}
